import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class CodeExchangeRateListItem extends SearchModelBase {
    exchageDate: string | null = null;
    fromExchageDate: string | null = null;
    toExchageDate: string | null = null;
    currency: string = '';
    rate: number|null = null;
    fromRate: number|null = null;
    toRate: number|null = null;
    createDate: string | null = null;
    fromCreateDate: string | null = null;
    toCreateDate: string | null = null;
    createBy: string = '';
    updateDate: string | null = null;
    fromUpdateDate: string | null = null;
    toUpdateDate: string | null = null;
    updateBy: string = '';
    id: number = 0;

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'DATE', width: 100, dataIndex: 'exchageDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 1, text: 'CUR', width: 50, dataIndex: 'currency'}),
        XCol.Create({ col: 2, text: 'RATE', width: 80, dataIndex: 'rate', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.0000'}),
        XCol.Create({ col: 3, text: 'Create Date', width: 120, dataIndex: 'createDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 4, text: 'Create By', width: 80, dataIndex: 'createBy'}),
        XCol.Create({ col: 5, text: 'Update Date', width: 120, dataIndex: 'updateDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 6, text: 'Update By', width: 80, dataIndex: 'updateBy'})
        ];


    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: CodeExchangeRateListItem.prototype.exchageDate, orderByAscending: false };

    public static formatData(data: CodeExchangeRateListItem[]) {
        return data.map((d: CodeExchangeRateListItem) => ({
          ...d,
        }));
    }
    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        exchageDate: {from: 'fromExchageDate', to: 'toExchageDate'},
        rate: {from: 'fromRate', to: 'toRate'},
        createDate: {from: 'fromCreateDate', to: 'toCreateDate'},
        updateDate: {from: 'fromUpdateDate', to: 'toUpdateDate'},
    }
}
